var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "cdk-overlay-container" }, [
        _c("div", {
          staticClass:
            "cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing",
        }),
        _c(
          "div",
          {
            staticClass: "cdk-global-overlay-wrapper",
            staticStyle: {
              "justify-content": "center",
              "align-items": "center",
            },
            attrs: { dir: "ltr" },
          },
          [
            _c(
              "div",
              {
                staticClass: "cdk-overlay-pane",
                staticStyle: { position: "static" },
                attrs: { id: "cdk-overlay-6" },
              },
              [
                _c("div", {
                  staticClass: "cdk-visually-hidden cdk-focus-trap-anchor",
                  attrs: { tabindex: "0", "aria-hidden": "true" },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cdk-dialog-container",
                    attrs: {
                      tabindex: "-1",
                      id: "cdk-dialog-6",
                      role: "dialog",
                      "aria-modal": "true",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ui-how-game-works-dialog ng-star-inserted",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-dialog modal-dialog_how-game-works",
                          },
                          [
                            _c("button", {
                              staticClass: "modal__close",
                              attrs: { type: "button" },
                              on: { click: _vm.hide },
                            }),
                            _c("div", { staticClass: "how-game-works" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "how-game-works__slider slider",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "slider__slides" },
                                    [
                                      _c(
                                        "swiper",
                                        {
                                          staticClass:
                                            "swiper swiper-initialized swiper-horizontal swiper-backface-hidden",
                                          attrs: {
                                            options: {
                                              loop: true,
                                              autoplay: false,
                                              slidesPerView: "auto",
                                              pagination: {
                                                el: ".swiper-pagination",
                                                clickable: true,
                                              },
                                              navigation: {
                                                nextEl: ".nav__button_next",
                                                prevEl: ".nav__button_prev",
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "swiper-slide",
                                            {
                                              staticClass:
                                                "slider__slide slide swiper-slide ng-star-inserted swiper-slide-active",
                                              staticStyle: { width: "560px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__media ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "video",
                                                    {
                                                      staticClass: "image",
                                                      attrs: {
                                                        autoplay: "",
                                                        playsinline: "",
                                                        disablepictureinpicture:
                                                          "",
                                                        disableremoteplayback:
                                                          "",
                                                        loop: "",
                                                      },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          type: "video/mp4",
                                                          src: "https://cs.fail/assets/video/Crash_1_en.mp4",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__content ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Mode description "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__text",
                                                    },
                                                    [
                                                      _c("pre", [
                                                        _vm._v(
                                                          "The point is to take the bet before the Crash happens.\nThe further he runs, the higher your bet multiplier will be, but the risk of losing on a Crash will also increase.\n\nGet juicy skins relying on your tactics and luck!"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "swiper-slide",
                                            {
                                              staticClass:
                                                "slider__slide slide swiper-slide ng-star-inserted swiper-slide-next",
                                              staticStyle: { width: "560px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__media ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "video",
                                                    {
                                                      staticClass: "image",
                                                      attrs: {
                                                        autoplay: "",
                                                        playsinline: "",
                                                        disablepictureinpicture:
                                                          "",
                                                        disableremoteplayback:
                                                          "",
                                                        loop: "",
                                                      },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          type: "video/mp4",
                                                          src: "https://cs.fail/assets/video/Crash_2_en.mp4",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__content ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__title",
                                                    },
                                                    [_vm._v(" How to play? ")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__text",
                                                    },
                                                    [
                                                      _c("pre", [
                                                        _vm._v(
                                                          'You can bet both with items from your inventory and with your balance.\nEnter the amount of the bet and the multiplier at which your bet will be automatically taken.\nClick "Create Bet" and wait for the round to start.\n\nP.S. You can make up to 2 bets in one round - just enable this option in the site settings'
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "swiper-slide",
                                            {
                                              staticClass:
                                                "slider__slide slide swiper-slide ng-star-inserted",
                                              staticStyle: { width: "560px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__media ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "video",
                                                    {
                                                      staticClass: "image",
                                                      attrs: {
                                                        autoplay: "",
                                                        playsinline: "",
                                                        disablepictureinpicture:
                                                          "",
                                                        disableremoteplayback:
                                                          "",
                                                        loop: "",
                                                      },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          type: "video/mp4",
                                                          src: "https://cs.fail/assets/video/Crash_3_en.mp4",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__content ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__title",
                                                    },
                                                    [_vm._v(" Game process ")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__text",
                                                    },
                                                    [
                                                      _c("pre", [
                                                        _vm._v(
                                                          "While character is running and the multiplier is growing, you can withdraw your bet at any time, or wait until it reaches your auto-withdrawal.\n\nHurry up to pick up the bet before the Crash.\n\nA crash can happen at any multiplier up to 10,000x!"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "swiper-slide",
                                            {
                                              staticClass:
                                                "slider__slide slide swiper-slide ng-star-inserted",
                                              staticStyle: { width: "560px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__media ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "video",
                                                    {
                                                      staticClass: "image",
                                                      attrs: {
                                                        autoplay: "",
                                                        playsinline: "",
                                                        disablepictureinpicture:
                                                          "",
                                                        disableremoteplayback:
                                                          "",
                                                        loop: "",
                                                      },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          type: "video/mp4",
                                                          src: "https://cs.fail/assets/video/Crash_5_en.mp4",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__content ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__title",
                                                    },
                                                    [_vm._v(" Bonus game ")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__text",
                                                    },
                                                    [
                                                      _c("pre", [
                                                        _vm._v(
                                                          "The first one to place a bet above the specified amount and catch the corresponding coefficient will receive an additional skin.\n\nA new game is created 3 minutes after the winner has been announced\n\nDon't miss your chance to get even more skins!"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "swiper-slide",
                                            {
                                              staticClass:
                                                "slider__slide slide slide_last swiper-slide ng-star-inserted swiper-slide-duplicate-prev",
                                              staticStyle: { width: "560px" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__media ng-star-inserted",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image",
                                                    attrs: {
                                                      src: "https://cs.fail/assets/images/modals/how-it-works-gabe.png",
                                                      alt: "",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "slide__content ng-star-inserted",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Any other questions?"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "In this case, you can read the FAQ section or watch the video"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "slide__actions",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "btn btn_grey-bordered intercomTrigger",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "btn__text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Go to FAQ"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "icon icon_support-alt",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass: "swiper-pagination",
                                            attrs: { slot: "pagination" },
                                            slot: "pagination",
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._m(0),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "cdk-visually-hidden cdk-focus-trap-anchor",
                  attrs: { tabindex: "0", "aria-hidden": "true" },
                }),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slider__nav nav" }, [
      _c(
        "button",
        {
          staticClass: "nav__button nav__button_prev btn btn_icon",
          attrs: { type: "button" },
        },
        [_c("i", { staticClass: "icon icon_circle-arrow-right" })]
      ),
      _c(
        "button",
        {
          staticClass: "nav__button nav__button_next btn btn_icon",
          attrs: { type: "button" },
        },
        [_c("i", { staticClass: "icon icon_circle-arrow-right" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }